<template>
	<div>
		<CarbarLink :underline="false" @click="toggleForm">
			<CarbarButton
				v-if="!showButtonOutlined"
				:is-full-width="false"
				class="mt-8"
			>
				Get in touch with a carbar business specialist
			</CarbarButton>
			<CarbarButton
				v-else
				:is-full-width="false"
				:is-outline="true"
				outline-color="group bg-transparent border border-white hover:bg-white"
			>
				<span
					class="font-medium text-white transition-all group-hover:text-sky-600"
				>
					Drop us an email
				</span>
			</CarbarButton>
		</CarbarLink>
		<FlexiModal
			ref="getInTouchRef"
			:show="getInTouchModal"
			:is-custom="true"
			:show-close-button="true"
			bg-color="bg-gray-100"
			inner-bg-color="bg-gray-100"
			inner-padding="p-0"
			custom-size="md:min-w-[600px] p-0"
			@close-modal="businessDetails.clearAllStates()"
		>
			<template #contentArea="{ closeModal }">
				<GetInTouchForm
					ref="getInTouchFormRef"
					@on-close="closeModal"
				/>
			</template>
		</FlexiModal>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import FlexiModal from '@/components/modals/FlexiModal.vue'
import { useBusinessDetails } from '@/stores/get-in-touch'
import GetInTouchForm from '@/components/forms/hubspot/GetInTouchForm.vue'

defineProps({
	showButtonOutlined: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const businessDetails = useBusinessDetails()
const getInTouchRef = ref(null)
const getInTouchModal = ref(false)

const toggleForm = () => {
	resetForm()
	getInTouchModal.value = !getInTouchModal.value
	gtmTrack('business_get_in_touch_click')
}

const getInTouchFormRef = ref(null)
const resetForm = () => {
	businessDetails.clearAllStates()
	businessDetails.clearErrors()
	getInTouchFormRef.value.resetFormFields()
}

const gtmTrack = (event) => {
	trackGtmEvent({ event })
}
</script>
